import { Badge, Flex, Text } from '@chakra-ui/react';
import { ImageWithSkeleton } from 'features/common/components/ImageWithSkeleton';
import { SitecoreContextResourceType } from 'features/context-ids/types/types';
import {
  getResourceDisplayConfig,
  isSensitiveResource,
} from 'features/context-ids/utils';
import { CONTEXT_IDS_TEXT } from 'features/context-ids/constants';
import { SensitiveResourceIcon } from 'features/context-ids/components/SensitiveResourceIcon';

export const generateResourcesTableData = (
  resources?: SitecoreContextResourceType[],
) =>
  resources?.map(
    ({ id, name, tenantDisplayName, tenantProductCode, type }) => ({
      id,
      name,
      tenantDisplayName,
      tenantProductCode,
      type,
    }),
  ) ?? [];

const renderAppCell = ({
  id,
  tenantProductCode,
  name,
  type,
}: Partial<SitecoreContextResourceType>) => {
  const { iconUrl, name: displayName } =
    getResourceDisplayConfig({ tenantProductCode, id, type }) ?? {};
  const isEdge = tenantProductCode === 'Edge';
  const isSensitive = isSensitiveResource(name, tenantProductCode, type);

  return (
    <Flex gap={2} alignItems='center'>
      <ImageWithSkeleton
        key={displayName}
        width='7'
        height='7'
        src={iconUrl}
        alt={displayName}
        flexShrink={0}
      />
      <Flex alignItems='center' gap={2}>
        <Text>{name}</Text>
        <Badge
          hidden={type !== 'edge'}
          textTransform='capitalize'
          colorScheme={isEdge ? 'success' : 'neutral'}
        >
          {isEdge
            ? CONTEXT_IDS_TEXT.LIVE_STATUS
            : CONTEXT_IDS_TEXT.PREVIEW_STATUS}
        </Badge>
        {isSensitive && <SensitiveResourceIcon size='sm' iconSize='16px' />}
      </Flex>
    </Flex>
  );
};

export const columns = [
  {
    id: 'name',
    Header: CONTEXT_IDS_TEXT.RESOURCES_HEADER,
    accessor: (row: SitecoreContextResourceType) => row.name,
    Cell: ({ row }: { row: { original: SitecoreContextResourceType } }) => {
      return renderAppCell(row.original);
    },
    disableSortBy: false,
  },
  {
    id: 'resource',
    Header: CONTEXT_IDS_TEXT.TENANT_HEADER,
    accessor: (row: SitecoreContextResourceType) => row.tenantDisplayName,
    disableSortBy: false,
  },
];
